export default __webpack_public_path__ + "static/small3@2x-0b39522d88be9b534bfb371bd804f1c9.jpg";